import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function IconLink(props) {
    const { url, icon } = props

    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={icon} className="icon-linkedin" />
        </a>
 )
}
